// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LoadsTable_wrap__AkBl3 {
  width: 100%;
  overflow-x: auto;
  /* Scrollbar minimalista (horizontal y vertical) */
  scrollbar-width: thin;
  scrollbar-color: color-mix(in srgb, var(--dylo-muted) 35%, transparent) transparent;
}
.LoadsTable_wrap__AkBl3::-webkit-scrollbar {
  height: 6px;
  width: 6px;
}
.LoadsTable_wrap__AkBl3::-webkit-scrollbar-track {
  background: transparent;
}
.LoadsTable_wrap__AkBl3::-webkit-scrollbar-thumb {
  background: color-mix(in srgb, var(--dylo-muted) 35%, transparent);
  border-radius: 3px;
}
.LoadsTable_wrap__AkBl3::-webkit-scrollbar-thumb:hover {
  background: color-mix(in srgb, var(--dylo-muted) 55%, transparent);
}

.LoadsTable_table__af5PA {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}

.LoadsTable_table__af5PA thead th {
  text-align: left;
  color: var(--dylo-muted);
  font-weight: 600;
  font-size: 12px;
  padding: 12px 14px;
  background: color-mix(in srgb, var(--dylo-muted) 8%, transparent);
  white-space: nowrap;
  position: sticky;
  top: 0;
}
.LoadsTable_table__af5PA thead th:first-child {
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
}
.LoadsTable_table__af5PA thead th:last-child {
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
}

.LoadsTable_table__af5PA tbody td {
  padding: 14px;
  color: var(--dylo-text);
  border-bottom: 1px solid var(--dylo-line);
  vertical-align: top;
}

.LoadsTable_row__lf-X5 {
  cursor: pointer;
  transition: background-color 0.12s ease;
  animation: LoadsTable_dylo-fade-in__K9jc6 0.3s ease both;
}
.LoadsTable_row__lf-X5:hover td {
  background: color-mix(in srgb, var(--dylo-teal-700) 7%, transparent);
}

.LoadsTable_criticalRow__m3YUT td {
  background: rgba(255, 77, 79, 0.08);
}
.LoadsTable_criticalRow__m3YUT:hover td {
  background: rgba(255, 77, 79, 0.15);
}
.LoadsTable_criticalRow__m3YUT td:first-child {
  border-left: 3px solid #ff4d4f;
}

.LoadsTable_pill__z3n5C {
  display: inline-block;
  text-align: center;
  padding: 5px 12px;
  border-radius: 15px;
  font-size: 11.5px;
  font-weight: 600;
  white-space: nowrap;
}

.LoadsTable_strong__PM4Pm {
  color: var(--dylo-ink);
  font-weight: 600;
}

.LoadsTable_empty__fMnTO {
  text-align: center;
  color: var(--dylo-muted);
  padding: 48px 0;
  font-size: 14px;
}
`, "",{"version":3,"sources":["webpack://./src/v2/pages/Loads/components/LoadsTable.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,gBAAgB;EAChB,kDAAkD;EAClD,qBAAqB;EACrB,mFAAmF;AACrF;AACA;EACE,WAAW;EACX,UAAU;AACZ;AACA;EACE,uBAAuB;AACzB;AACA;EACE,kEAAkE;EAClE,kBAAkB;AACpB;AACA;EACE,kEAAkE;AACpE;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,iEAAiE;EACjE,mBAAmB;EACnB,gBAAgB;EAChB,MAAM;AACR;AACA;EACE,4BAA4B;EAC5B,+BAA+B;AACjC;AACA;EACE,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,uCAAuC;EACvC,wDAAsC;AACxC;AACA;EACE,oEAAoE;AACtE;;AAEA;EACE,mCAAmC;AACrC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,eAAe;EACf,eAAe;AACjB","sourcesContent":[".wrap {\n  width: 100%;\n  overflow-x: auto;\n  /* Scrollbar minimalista (horizontal y vertical) */\n  scrollbar-width: thin;\n  scrollbar-color: color-mix(in srgb, var(--dylo-muted) 35%, transparent) transparent;\n}\n.wrap::-webkit-scrollbar {\n  height: 6px;\n  width: 6px;\n}\n.wrap::-webkit-scrollbar-track {\n  background: transparent;\n}\n.wrap::-webkit-scrollbar-thumb {\n  background: color-mix(in srgb, var(--dylo-muted) 35%, transparent);\n  border-radius: 3px;\n}\n.wrap::-webkit-scrollbar-thumb:hover {\n  background: color-mix(in srgb, var(--dylo-muted) 55%, transparent);\n}\n\n.table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 13px;\n}\n\n.table thead th {\n  text-align: left;\n  color: var(--dylo-muted);\n  font-weight: 600;\n  font-size: 12px;\n  padding: 12px 14px;\n  background: color-mix(in srgb, var(--dylo-muted) 8%, transparent);\n  white-space: nowrap;\n  position: sticky;\n  top: 0;\n}\n.table thead th:first-child {\n  border-top-left-radius: 10px;\n  border-bottom-left-radius: 10px;\n}\n.table thead th:last-child {\n  border-top-right-radius: 10px;\n  border-bottom-right-radius: 10px;\n}\n\n.table tbody td {\n  padding: 14px;\n  color: var(--dylo-text);\n  border-bottom: 1px solid var(--dylo-line);\n  vertical-align: top;\n}\n\n.row {\n  cursor: pointer;\n  transition: background-color 0.12s ease;\n  animation: dylo-fade-in 0.3s ease both;\n}\n.row:hover td {\n  background: color-mix(in srgb, var(--dylo-teal-700) 7%, transparent);\n}\n\n.criticalRow td {\n  background: rgba(255, 77, 79, 0.08);\n}\n.criticalRow:hover td {\n  background: rgba(255, 77, 79, 0.15);\n}\n.criticalRow td:first-child {\n  border-left: 3px solid #ff4d4f;\n}\n\n.pill {\n  display: inline-block;\n  text-align: center;\n  padding: 5px 12px;\n  border-radius: 15px;\n  font-size: 11.5px;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.strong {\n  color: var(--dylo-ink);\n  font-weight: 600;\n}\n\n.empty {\n  text-align: center;\n  color: var(--dylo-muted);\n  padding: 48px 0;\n  font-size: 14px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `LoadsTable_wrap__AkBl3`,
	"table": `LoadsTable_table__af5PA`,
	"row": `LoadsTable_row__lf-X5`,
	"dylo-fade-in": `LoadsTable_dylo-fade-in__K9jc6`,
	"criticalRow": `LoadsTable_criticalRow__m3YUT`,
	"pill": `LoadsTable_pill__z3n5C`,
	"strong": `LoadsTable_strong__PM4Pm`,
	"empty": `LoadsTable_empty__fMnTO`
};
export default ___CSS_LOADER_EXPORT___;
